<template>
    <div>
      <div class="survey-module-right-action">
          <div class="table-controls justify-between">
              <div class="table-controls-btn align-center">
                <!-- <div class="table-controls-btn-item btn-color1" @click="handleOpen()">新增</div> -->
                 <span></span>
              </div>
              <div class="table-controls-btn align-center">
                <input type="text" v-model="queryParams.memberCode" placeholder="请输入会员证书编码" autocomplete="off">
                <div class="table-controls-btn-item btn-color3" @click="handleQuery()">搜索</div>
                <div class="table-controls-btn-item btn-color4" @click="resetQuery()">重置</div>
              </div>
            </div>
            <div class="table-body">
              <el-table
                v-loading="loading"
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                :header-cell-style="{background:'#72b701',color:'#fff'}"
              >
                <el-table-column prop="name" label="姓名" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="sex" label="性别" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="phone" label="电话" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="birthDate" label="出生日期" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="nativePlace" label="籍贯" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="major" label="专业" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="partyAffiliation" label="党派" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="nation" label="民族" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="degreeEducation" label="文化程度" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="membershipTime" label="入会时间" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="expirationTime" label="到期时间" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="duty" label="本会职务" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="title" label="技术职称与级别" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="workUnit" label="工作单位及职务" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="academicDegree" label="学位" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="address" label="通讯处" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="postalCode" label="邮编" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="wechat" label="微信" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="education" label="学历" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="invent" label="重要科技发明、著作、学术论文(何时、何地出版或发表)" align="center" min-width="420" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="reward" label="受过何种奖励" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="languages" label="懂何种外语" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="remark" label="备注" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="memberCode" label="会员证书编码" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <!-- <el-table-column prop="memberAccount" label="会员账号" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="name" label="姓名" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="email" label="邮箱" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="createTime" label="注册时间" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="expirationTime" label="到期时间" align="center" :show-overflow-tooltip="true"></el-table-column> -->
                <!-- <el-table-column
                  fixed="right"
                  label="操作"
                  align="center">
                  <template slot-scope="scope">
                    <el-button @click="handleOpen(scope.row)" type="text" size="small">编辑</el-button>
                    <el-button type="text" size="small" @click="deleteItemFun(scope.row.id)">删除</el-button>
                  </template>
                </el-table-column> -->
              </el-table>
            </div>
            <div class="pagination-content justify-end">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="queryParams.pageNum"
                  :page-size="queryParams.pageSize"
                  background
                  layout="total,prev, pager, next, jumper"
                  prev-text="上一页"
                  next-text="下一页"
                  :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
          :title="dialog.title"
          :visible.sync="dialog.visible"
          width="40%"
          :before-close="closeDialog"
          >
          <div class="login-form-box">
            <el-form :model="referForm" :rules="referRules" ref="referForm">
              <el-form-item prop="memberAccount">
                <input v-model="referForm.memberAccount" placeholder="账号" autocomplete="new-password">
              </el-form-item>
              <el-form-item prop="password" v-if="dialog.title=='新增'">
                <input v-model="referForm.password" placeholder="密码" type="password" autocomplete="new-password">
              </el-form-item>
              <el-form-item prop="name">
                <input v-model="referForm.name" placeholder="姓名" autocomplete="new-password">
              </el-form-item>
              <el-form-item prop="identityCard">
                <input v-model="referForm.identityCard" placeholder="身份证号" autocomplete="new-password">
              </el-form-item>
              <el-form-item prop="email">
                <input v-model="referForm.email" placeholder="邮箱" autocomplete="new-password">
              </el-form-item>
              <el-form-item>
                <div class="login-form-btn justify-center align-center" @click="handleSubmit('referForm')">提交{{ dialog.title }}</div>
              </el-form-item>
            </el-form>
           </div>
        </el-dialog>
    </div>
  </template>
  
  <script>
  import { getList, addItem, editItem, delItem } from "@/api/hygl";
  export default {
    data(){
      return{
        loading:false,
        // 列表1-start
        ruleForm: {
          memberAccount: '',
          name:'',
          certificateNumber:''
        },
        
        queryParams:{
          pageNum: 1,
          pageSize: 10,
          memberCode: "",
        },
        total:0,
        tableData: [],
        dialog:{
          title:'',
          visible:false
        },
        referForm: {
          id: undefined,
          memberAccount: "",
          password: "",
          name: "",
          identityCard: "",
          email: "",
        },
        referRules: {
          memberAccount: [{ required: true, message: "请输入账号", trigger: "blur" }],
          password: [{ required: true, message: "请输入密码", trigger: "blur" }],
          name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
          identityCard: [
            { required: true, message: "请输入身份证号", trigger: "blur" },
            {
              pattern:
                /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
              message: "证件号码格式有误！",
              trigger: "blur",
            },
          ],
          email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        },
        // 列表1-end
        identity:localStorage.getItem("identity")
      }
    },
    created(){
      if(this.identity=='admin'){
        this.handleQuery()
      }
    },
    methods:{
      handleOpen(row){
        if(row){
          for(let key in this.referForm){
            if(key=='password'){
              this.referForm[key] = ''
            }else{
              this.referForm[key] = row[key]
            }
          }
        }
        this.dialog.title = row?'编辑':'新增'
        this.dialog.visible = true
      },
      handleCurrentChange(val) {
        this.queryParams.pageNum = val
        this.handleQuery()
      },
   
      /** 查询 */
      handleQuery() {
        this.loading = true;
        getList(this.queryParams)
          .then(({ data }) => {
            this.tableData = data.list;
            this.total = data.total;
          })
          .finally(() => {
            this.loading = false;
          });
      },
      /** 角色保存提交 */
      handleSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            const roleId = this.referForm.id;
            if (roleId) {
              editItem(roleId, this.referForm)
                .then((res) => {
                  this.$message({type: 'success', message: res.message});
                  this.closeDialog();
                  this.resetQuery();
                })
                .finally(() => {
                  this.loading = false
                });
            } else {
              addItem(this.referForm)
                .then((res) => {
                  this.$message({type: 'success', message: res.message});
                  this.closeDialog();
                  this.resetQuery();
                })
                .finally(() => {
                  this.loading = false
                });
            }
          }
        });
      },
      /** 关闭表单弹窗 */
      closeDialog() {
        this.dialog.visible = false;
        this.resetForm();
      },
      /** 重置表单 */
      resetForm() {
        this.referForm.id = undefined;
        this.referForm.memberAccount = '';
        this.referForm.password = '';
        this.referForm.name = '';
        this.referForm.identityCard = '';
        this.referForm.email = '';
        this.queryParams.pageNum = 1
        this.handleQuery()
      },
      /** 重置查询 */
      resetQuery() {
        this.queryParams.pageNum = 1;
        this.queryParams.memberCode = ''
        this.handleQuery();
      },
      deleteItemFun(id){ 
        this.$confirm('此操作将永久删除此会员, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            delItem([id]).then((res)=>{
              this.handleQuery()
              this.$message({
                type: 'success',
                message: res.message
              });
            })
           
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });          
          });
      },
    }
  }
  </script>
<style scoped lang="css" src="../../views/member-page/assets/css/rem.css" />